import mixitup from 'mixitup';
import mixitupMultifilter from './multifilter.js';
import Gator from 'gator';

mixitup.use(mixitupMultifilter);

_gg.onReady.ResetMixItUp = function () {
    let filter = document.querySelectorAll('[data-filter-group]');
    for (let i = 0; i < filter.length; i++) {
        let active = filter[i].querySelector('input[type="radio"]:checked');
        if (active) {
            filter[i].active = active.value;
        }
        Gator(filter[i]).on('click', 'input[type="radio"]', function () {
            if (filter[i].active == this.value) {
                let reset = filter[i].querySelector(
                    'input[type="radio"].-reset'
                );
                if (reset) {
                    reset.click();
                }
            } else {
                filter[i].active = this.value;
            }
        });
    }
};

export default mixitup;
